<template>
<div class="page-wrapper">
  <search-list
     :projectList="projectList"
     :areaList="areaList"
     :categoryList="categoryList"
     :sourceList="sourceList"
     :goodsList="goodsList"
     :stateList="stateList"
     @changeProject="changeProject"
    @findData="findData">
  </search-list>
  <div class="page-wrapper">
    <table-list
        :columns="columns"
        :data="tableData"
        :total="total"
        :current="current"
        :loading="loading"
        @change-page="changePage"
      >
      <Button type="primary" class="mb16" @click="createRepaireOrder" v-p="{api:'repair/order'}">新建维修单</Button>
    </table-list>
  </div>
  <create-modal :n="createKey" :spaceList = "areaList" @refresh="findData(searchData)"></create-modal>
  <cancle-modal :n = "cancleKey" :order_sn = "orderSn" @refresh="findData(searchData)"></cancle-modal>
</div>
</template>

<script type="text/ecmascript-6">
import { getProjects } from 'api/common'
import { formatDateTime } from '@/utils/format'
import { getList,getCondition } from 'api/repaire'
import SearchList from './components/SearchList'
import CreateModal from './components/CreateModal'
import CancleModal from './components/CancleModal'
import TableList from "components/TableList/index"

export default {
  name:'repair',
  created(){
    this.initData()
  },
  components:{
    SearchList,
    TableList,
    CreateModal,
    CancleModal
  },
  data () {
    return {
      loading:false, // true
      total:0,
      current:1,
      createKey:0,
      cancleKey:0,
      orderSn:'',
      searchData:{
        projectFid:'',
        spaceid:'',
        categoryCode:'',
        goodsCode:'',
        businessSource:13,// 默认自如寓
        orderStatus:'',
        createTimeEnd:'',
        createTimeStart:'',
        visitTimeStart:'',
        visitTimeEnd:'',
        keyWords:'',
        limit: 10,
        page: 1
      },
      projectList:[],
      areaList:[],
      categoryList:[],
      goodsList:[],
      sourceList:[],
      stateList:[],
      columns:[
        {
        type:'index',
        width:60,
        align:'center'
        },
        {
          title:' ',
        },
        {
          title:'维修单号',
          key:'orderSn',
          align:'center',
          width:180,
          render: (h,params) => {
            return h('a',{
              on:{
                click: () => {
                  this.$router.push({
                    name: 'repairedetail',
                    query:{
                      orderSn: params.row.orderSn
                    }
                  })
                }
              }
            },
            params.row.orderSn
            )
          }
        },
        {
          title:' ',
        },
        {
          title:'状态',
          key:'orderStatusName',
          align:'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '项目',
          key: 'projectName',
          align: 'center',
          width:180
        },
        {
          title:' ',
        },
        {
          title: '区域类型',
          key: 'areaType',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '功能区/房间号',
          key: 'houseCode',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '空间',
          key: 'spaceName',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '大类',
          key: 'categoryName',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '物品',
          key: 'goodsName',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        // {
        //   title: '紧急程度',
        //   key: 'emergencyDegree',
        //   align: 'center',
        //   width:120
        // },
        {
          title:' ',
        },
        {
          title: '预约上门时间',
          key: 'visitTimeFlag',
          align: 'center',
          width:180,
          render: (h,params) => {
            return h('div',params.row.visitTimeFlag+ ' ' +params.row.visitTime)
          }
        },
        {
          title:' ',
        },
        {
          title: '联系人',
          key: 'visitLinkman',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '联系人手机',
          key: 'visitMobile',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title: '创建时间',
          key: 'createDate',
          align: 'center',
          width:120
        },
        {
          title:' ',
        },
        {
          title:'操作',
          key:'action',
          align:'center',
          fixed:'right',
          width:150,

          render: (h,params) =>{
            let show = params.row.orderStatus === "TO_SEND" || params.row.orderStatus === "TO_BE_ASSIGNED" || params.row.orderStatus === "WAITING" || params.row.orderStatus === "SIGN"
            return h('a',{
              // 仅当状态为待自如派单、待供应商派工、待师傅接单、待师傅签到时展示
              style: {
                marginRight: '5px',
                display: show ? 'inline-block' : 'none'
              },
              directives:[
                {
                  name:'p',
                  value:{
                    api:'repair/cancelRepairOrder'
                  }
                }
              ],
              on:{
                click: () => {
                  this.cancleKey ++
                  this.orderSn = params.row.orderSn
                }
              }
            },'取消')
          }
        }
      ],
      tableData:[]
    };
 },
 methods:{
   changePage(n){
      this.loading  = true
      this.current = n;
      this.searchData.page = n
      this.getList(this.searchData)
    },
    createRepaireOrder(){
      this.createKey++
    },
    getList(data){
      this.loading = true
      getList(data).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
     initData() {
         getProjects().then(res => {
             this.projectList = res.data
             this.searchData.projectFid = res.data[0].value
             this.initCondition(this.searchData.projectFid)
             this.getList(this.searchData)
         })

     },
     initCondition(projectFid) {
         getCondition({projectFid: projectFid}).then(res => {
             this.areaList = res.data.area
             this.sourceList = res.data.source
             this.stateList = res.data.state
             this.categoryList = res.data.category
         })
     },
     changeProject(projectFid) {
         this.initCondition(projectFid)
     },
   findData(data){
     this.current = 1;
     this.searchData = data
     this.searchData.page = 1
     this.getList(this.searchData)
   }
 }
}
</script>
